import axios from 'axios';

const API_URL = '/api/auth';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const authService = {
  /**
   * Register a new user
   */
  async register(email, password) {
    try {
      const response = await axios.post(`${API_URL}/register`, {
        email,
        password
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Registration failed'
      };
    }
  },

  /**
   * Login a user
   */
  async login(email, password, rememberMe = false) {
    try {
      const response = await axios.post(`${API_URL}/login`, {
        email,
        password,
        remember_me: rememberMe
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Login failed'
      };
    }
  },

  /**
   * Logout the current user
   */
  async logout() {
    try {
      const response = await axios.post(`${API_URL}/logout`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Logout failed'
      };
    }
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser() {
    try {
      const response = await axios.get(`${API_URL}/me`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get user'
      };
    }
  },

  /**
   * Check if user is authenticated
   */
  async checkAuth() {
    try {
      const response = await axios.get(`${API_URL}/check-auth`);
      return {
        success: true,
        authenticated: response.data.authenticated,
        user: response.data.user
      };
    } catch (error) {
      return {
        success: false,
        authenticated: false,
        error: error.response?.data?.error || 'Auth check failed'
      };
    }
  },

  /**
   * Request password reset
   */
  async forgotPassword(email) {
    try {
      const response = await axios.post(`${API_URL}/forgot-password`, {
        email
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Request failed'
      };
    }
  },

  /**
   * Reset password with token
   */
  async resetPassword(token, password) {
    try {
      const response = await axios.post(`${API_URL}/reset-password`, {
        token,
        password
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Password reset failed'
      };
    }
  }
};

export default authService;
